import { Link, Outlet } from "@tanstack/react-router";

export function ConsoleShell() {
  return (
    <div className="console-shell">
      <aside className="console-sidebar">
        <div>
          <a href="/console/records" className="console-brand">
            总管 AI
          </a>
          <p className="console-kicker">控制台</p>
        </div>

        <nav aria-label="控制台模块" className="console-nav">
          <Link to="/console/records" activeProps={{ "aria-current": "page" }}>
            记录
          </Link>
        </nav>

        <details className="app-switcher">
          <summary>切换应用</summary>
          <div className="app-switcher-menu">
            <a href="/chat">对话</a>
            <a href="/workspace">经典工作台</a>
          </div>
        </details>
      </aside>

      <div className="console-content">
        <Outlet />
      </div>
    </div>
  );
}

export function ConsoleNotFound() {
  return (
    <main className="console-page console-empty-state">
      <p className="console-kicker">404</p>
      <h1>找不到这个控制台页面</h1>
      <p>地址可能已经失效，或者对应模块尚未提供。</p>
      <Link to="/console/records" className="primary-link">
        返回记录列表
      </Link>
    </main>
  );
}
